export default __webpack_public_path__ + "static/logo-5b99bd8d096d93ba925032be89255937.png";